import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconReply$1 = /*@__PURE__*/ proxyCustomElement(class WppIconReply extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-reply", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M4.31 9.49981L7.27297 12.4628C7.56586 12.7557 7.56586 13.2305 7.27297 13.5234C7.0067 13.7897 6.59004 13.8139 6.29643 13.596L6.21231 13.5234L1.96967 9.28078C1.7034 9.01452 1.6792 8.59785 1.89705 8.30424L1.96967 8.22012L6.21231 3.97748C6.5052 3.68459 6.98008 3.68459 7.27297 3.97748C7.53924 4.24375 7.56344 4.66041 7.34559 4.95402L7.27297 5.03814L4.31 7.99981L10 8.00045C14.1979 8.00045 17.6162 11.3381 17.7462 15.5044L17.75 15.7505C17.75 16.1647 17.4142 16.5005 17 16.5005C16.5858 16.5005 16.25 16.1647 16.25 15.7505C16.25 12.3754 13.5748 9.62514 10.2291 9.50458L10 9.50045L4.31 9.49981L7.27297 12.4628L4.31 9.49981Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-reply-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-reply", "wpp-icon-reply-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-reply-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-reply-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconReply$1);
      }
      break;
  } });
}

const WppIconReply = WppIconReply$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconReply, defineCustomElement };
